import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgThumbsDown({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.32 4.5h11.681a3 3 0 013 3v6a3 3 0 01-3 3h-2.289a3 3 0 01-.512.756l-4.23 4.558-.012.012a2.18 2.18 0 01-3.137.014 2.262 2.262 0 01-.597-2.016L8.764 17H6.05a4 4 0 01-3.677-5.576l2.189-5.106A3 3 0 017.32 4.5zm9.51 2c.111.313.172.65.172 1v7h2a1 1 0 001-1v-6a1 1 0 00-1-1H16.83zm-2.096 9.395a1 1 0 00.267-.68V7.5a1 1 0 00-1-1h-6.68a1 1 0 00-.92.606l-2.188 5.106A2 2 0 006.05 15h5.13l-.227 1.188-.766 4.015a.263.263 0 00.058.235c.082.081.19.082.266.007l4.222-4.55z"
        fill={color}
      />
    </svg>
  )
}

export default SvgThumbsDown
